import { Button, Skeleton, DatePicker, Card, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { TimePicker } from "antd";
import CustomDrawer from "../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../Elements/CustomSelect";
import TreeSelectCustom from "../../../../Elements/TreeSelect/TreeSelectCustom";
import {
  calculateDateRangeFromDate,
  generatedISOFormatDateString,
} from "../../../../../Utils/DateConverstion";
import { objectToQueryString } from "../../../../../Utils/CommonFunctions";

// import errorNew from "../../../../assets/error/error.png";
import TreeSelectCustomWithSelectAll from "../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import { useStoreUpdaterWithAPI } from "../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../Common/APIConstants";
import { useSelector } from "react-redux";

const { RangePicker } = TimePicker;

const WaterHistoricalTrends = () => {
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState();
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);
  const [chartInput, setChartInput] = useState(null);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();

  const [chartLoading, setChartLoading] = useState(false);

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);

  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;



  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        id: "historical-trends",
        height: 350,
        type: "line",
        zoom: {
          type: "x",
          enabled: true,
          // autoScaleYaxis: true,
        },
        toolbar: {
          autoSelected: "zoom",
        },
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        floating: false,
        fontSize: '14px',
        fontFamily: 'Helvetica, Arial',
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: 0,
        offsetY: 0,
        labels: {
            colors: undefined,
            useSeriesColors: false
        },
        markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0
        },
        itemMargin: {
            horizontal: 5,
            vertical: 10
        },
        onItemClick: {
            toggleDataSeries: true
        },
        onItemHover: {
            highlightDataSeries: false
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      markers: {
        size: 5,
        strokeOpacity: 0.3,
        hover: {
          size: undefined,
          sizeOffset: 3,
        },
      },
      title: {
        // display: true,
        text: "Historical Trends",
        // color:  'red',

        style: {
   color: isdarkMode ? "#FFFFFF" : "#000000",
              // className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"}`
           fontSize: "18px", 
           fontWeight: "bold" },
        
      },
      xaxis: {
        categories: [],
        labels: { 
          style: { 
            color: "red",
          }
        },
        title: { 
          text: "Date", 
          style: {
            color: isdarkMode ? "#FFFFFF" : "#000000",
          }
        }
      },
      yaxis: {
        title: {
          text: "Value",
        },
      },
      // tooltip: {
      //   y: [
      //     {
      //       title: {
      //         formatter: function (val) {
      //           return val + " (mins)";
      //         },
      //       },
      //     },
      //     {
      //       title: {
      //         formatter: function (val) {
      //           return val + " per session";
      //         },
      //       },
      //     },
      //     {
      //       title: {
      //         formatter: function (val) {
      //           return val + "Kg";
      //         },
      //       },
      //     },
      //   ],
      // },
      tooltip: {
        x: {
          show: true,
          format: "dd-MMM",
          formatter: undefined,
        },
        y: {
          title: {
            formatter: (
              seriesName,
              { series, seriesIndex, dataPointIndex, w }
            ) => {
              const isFlowRate = seriesName.includes("flowRate");
              const kgLabel = isFlowRate ? " Kg/hr" : "Kg";

              // Assuming opts.value contains the actual y-axis value
              return seriesName + kgLabel;
            },
          },
        },
      },
    },
  });

  const inputData = {
    SectionID: 1,
    ConverterorGroupID: 2,
    MeterIds: "1",
    FromDate: "2023-09-21T07:15:00.000Z",
    ToDate: "2023-09-25T07:15:00.000Z",
  };


  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowSectionResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_CONVERTER_DETAILS}`
      }).then((res) => {
        console.log(res)
        setgetFlowConverterResData(res);
      });

    makeRequest({  
        type: APIConstants.GET, 
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_STEAM_FLOW_GROUP_DETAILS}`
      }).then((res) => {
        console.log(res)
        setflowGroupDetailsResData(res);
      });

   
  },[])

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_NS_CONVERTER_DETAILS}?ConverterID=${converterGroupId}` 
      }).then((res) => {
        console.log(res) 
        setnsGetFlowConverterResData(res);
      });

    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.GET_FLOW_STEAM_GROUP_METER_DETAILS}?GroupID=${converterGroupId}` 
      }).then((res) => {
        console.log(res)
        setgetFlowSteamGroupMeterResData(res);
      });
  },[converterGroupId])

  
  const getResponse =(inputData)=>{
    console.log(inputData)
    
    makeRequest({ 
        type: APIConstants.GET,  
        // GetFlowSteamGropeMeterDetails?GroupID=81
        // http://20.244.40.160:81/TVSDashBoard/GetsteamHistoricalDetails?SectionID=1&ConverterorGroupID=24&MeterIds=21,22,23&FromDate=2024-7-11T13:08:50.000Z&ToDate=2024-7-19T13:08:55.000Z
        url: `${APIConstants.GET_HISTORICAL_DETAILS_WATER}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}` 
      }).then((res) => {
        console.log(res)
        setsteamHistoricalData(res);
      });
  }

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      MeterIds: ids || [1],
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    getResponse(inputData)
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };

  useEffect(() => {
    setChartInputData();
  }, []);

  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  }, [steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(false); 
    }
  };

  const updateChart = async () => {
    try {
      setChartLoading(true);
      const selectedMeterData = steamHistoricalData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterid)
      );
      // transform the data in a chart series format
      const transformData = (property, meterName) => {
        const data = selectedMeterData
          ?.filter((item) => item?.metername === meterName)
          ?.map((item) => item[property]);
        const seriesData = {
          name: `${property}-${meterName}`, // Concatenate property and METERNAME
          data,
        };
        return seriesData;
      };
      const properties = selectedValues;
      const seriesData = [];

      // Iterate over selected meter IDs and properties
      selectedMeterIds?.forEach((id) => {
        const meterName =
          sectionId === 1
            ? nsGetFlowConverterList?.find(
                (item) => item?.meterid === Number(id)
              ).metername
            : getFlowSteamGroupMeterList?.find(
                (item) => item?.meterID === Number(id)
              ).meterName;
        properties.forEach((property) => {
          seriesData.push(transformData(property, meterName));
        });
      });

      const datesArray = [];
      const date = ["createdON"];
      selectedMeterIds?.forEach((id) => {
        const meterName =
          sectionId === 1
            ? nsGetFlowConverterList?.find(
                (item) => item?.meterid === Number(id)
              ).metername
            : getFlowSteamGroupMeterList?.find(
                (item) => item?.meterID === Number(id)
              ).meterName;
        date.forEach((property) => {
          datesArray.push(transformData(property, meterName));
        });
      });
      const firstOption = selectedValues.includes("flowRate");
      const secondOption = selectedValues.includes("cumulative");
      const finalData = seriesData?.filter((series) => {
        if (firstOption && secondOption) {
          // Both options selected, keep all series
          return true;
        } else if (firstOption) {
          // First option selected, add series with "FlowRate"
          return series.name.includes("flowRate");
        } else if (secondOption) {
          // Second option selected, add series with "Cumulative"
          return series.name.includes("cumulative");
        }
        // If neither option selected, keep all series
        return true;
      });

      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);

      const reversedFinalData = finalData.map((data) => {
        return { data: data.data.reverse(), name: data.name };
      });

      // // x axis input
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      // update in columnData
      setChartData((prevChartData) => ({
        series: reversedFinalData || [],
        options: {
          ...prevChartData.options,
          xaxis: {
            ...prevChartData.options.xaxis,
            categories: localDateTime || [],
          },
        },
      }));
      setChartLoading(false);
    } catch (err) {
      console.log(err);
      setChartLoading(false);
    }
  };

  const onChangeFromDate = (date, dateString) => {
    setFromDateString(dateString);
    setFromDateObj(date);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (date, dateString) => {
    setToDateString(dateString);
    setToDateObj(date);
    if (dateString) {
      setToDateError("");
    }
  };

  const parameters = [
    { id: 1, name: "flowRate" },
    { id: 2, name: "cumulative" },
  ];

 

  return (
    <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode'} `}>
      {isLoading  &&(
        <div className="absolute inset-0 flex justify-center items-center bg-white dark:bg-gray-800 bg-opacity-75 dark:bg-opacity-75 z-10">
          <Spin active paragraph={{ rows: 6 }} />
        </div>
      )}

      <Card
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode"} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{ position: 'relative', overflow: 'hidden' }}
      >


        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="line"
          height={500}
          className="w-full"
        />

        </Card>


        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            nameKey={sectionId === 1 ? "sitename" : "groupName"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterID"}
            valueKey={sectionId === 1 ? "meterid" : "meterID"}
            nameKey={sectionId === 1 ? "metername" : "meterName"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameters}
            idKey="id"        
            nameKey="name"     
            valueKey="name"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">From Date:</label>
            <DatePicker
              value={fromDateObj}
              onChange={onChangeFromDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">To Date:</label>
            <DatePicker
              value={toDateObj}
              onChange={onChangeToDate}
              className={`   ${isdarkMode ? 'datebackground' : 'whitemode'} w-80 `}
              dropdownClassName={isdarkMode ? 'datedropdown' : 'whitemode'}
              showTime={{ format: "HH:mm:ss" }}
              format="YYYY-MM-DD HH:mm:ss"
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {toDateError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            className="blue-btn"
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button> 
        </div>
      </CustomDrawer>
    </div>
  );
};

export default WaterHistoricalTrends;
